import { Modal } from 'antd'
import React from 'react'

// 리뷰 상세보기 팝업 모달
const ReviewDetailComponent = ({
  reviewDetailModalShow,
  setReviewDetailModalShow,
  currentReviewId,
  searchOptions,
  orderType,
  orderBy,
  getReadReviews,
  reviewList,
  imageList,
  setImageList,
}) => {
  // const [user, setUser] = useRecoilState(userState)
  // const [isLoading, setIsLoading] = useState(true)
  // const [currReview, setCurrReview] = useState({})
  // const [prevReview, setPrevReview] = useState({})
  // const [nextReview, setNextReview] = useState({})
  // const [isPhotoReview, setIsPhotoReview] = useState(false)
  // const [currentPhotoIdx, setCurrentPhotoIdx] = useState(0)

  /**
   * 리뷰 이미지가 1개 이상인 경우 이미지 목록 render
   * @returns {*[]}
   */
  // const renderReviewImageList = () => {
  //   let imageList = []

  //   for (let i = 0; i < currReview.reviewImgList.length; i++) {
  //     const currImgItem = currReview.reviewImgList[i]
  //     let source = `${process.env.REACT_APP_S3_HOST}/image/review/${
  //       currReview.productId
  //     }/${currReview.createdBy}_${currImgItem.imgName}.${currImgItem.imgType}`
  //     imageList.push({ idx: i, source })
  //   }

  //   return imageList
  // }

  /**
   * 리뷰 이미지 목록에 있는 이미지 클릭 시 실행
   * @param idx
   */
  // const handleReviewImageListClick = (idx) => {
  //   setCurrentPhotoIdx(idx)
  // }

  /**
   * 리뷰 평점 별 render
   * @param value
   * @returns {JSX.Element}
   */
  // const renderReviewStar = (value) => {
  //   let scoreList = []
  //   for (let i = 0; i < value; i++) {
  //     scoreList.push(
  //       <img
  //         key={`empty_star_${currReview.id}_${i + 1}`}
  //         className={`${styles['review-score-img']}`}
  //         src={`${process.env.REACT_APP_HOST}/assets/icon/inquiry/selectGrade.png`}
  //       />,
  //     )
  //   }
  //   if (value !== 5) {
  //     for (let i = 0; i < 5 - value; i++) {
  //       scoreList.push(
  //         <img
  //           key={`star_${currReview.id}_${i + 1}`}
  //           className={`${styles['review-score-img']}`}
  //           src={`${process.env.REACT_APP_HOST}/assets/icon/inquiry/unSelectGrade.png`}
  //         />,
  //       )
  //     }
  //   }
  //   return (
  //     <Row align="middle" wrap={false} style={{ padding: '0' }}>
  //       {scoreList.map((score) => score)}
  //       &nbsp;
  //       {value}
  //     </Row>
  //   )
  // }

  /**
   * 리뷰 베스트 선정/해제 버튼 클릭 시 실행
   * @returns {Promise<void>}
   */
  // const handleReviewBest = async () => {
  //   const isBestResult = currReview.isBest
  //   Swal.fire({
  //     title: isBestResult
  //       ? '선택된 베스트리뷰를 해제하시겠습니까?\n(상품페이지 리뷰 상단에서 노출되지 않게 됩니다.)'
  //       : '베스트리뷰 선정 시 사진이 첨부되었거나 꼼꼼하게 작성된 리뷰를 선정해주세요.\n(선정된 베스트리뷰는 상품페이지 리뷰 상단에 자동으로 노출됩니다.)',
  //     customClass: 'custom-alert',
  //     confirmButtonColor: isBestResult ? '#ff4d4f' : '#117ffa',
  //     confirmButtonText: '확인',
  //     showCancelButton: true,
  //     cancelButtonText: '취소',
  //   }).then(async ({ isConfirmed }) => {
  //     if (isConfirmed) {
  //       setIsLoading(true)
  //       const param = {
  //         editList: [currReview.id],
  //         editKey: 'is_best',
  //         is_best: !isBestResult,
  //       }
  //       const res = await inquiryApi.editReview(param, user.id)
  //       if (res.data.code === 200) {
  //         Swal.fire({
  //           title: '정상적으로 수정이 완료되었습니다.',
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //         await getOneReview(currReview.id, null)
  //         getReadReviews()
  //         setIsLoading(false)
  //       } else if (res.data.code === 999) {
  //         setIsLoading(false)
  //         Swal.fire({
  //           title: res.data.msg,
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //       } else {
  //         setIsLoading(false)
  //         Swal.fire({
  //           title:
  //             '해당 내용을 수정하는데 실패했습니다.\n관리자에게 문의하시길 바랍니다.',
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //       }
  //     }
  //   })
  // }

  /**
   * 리뷰 노출
   * @returns {Promise<void>}
   */
  // const handleReviewShow = async () => {
  //   Swal.fire({
  //     title: '노출 처리하시겠습니까?',
  //     customClass: 'custom-alert',
  //     confirmButtonColor: '#117ffa',
  //     confirmButtonText: '확인',
  //     showCancelButton: true,
  //     cancelButtonText: '취소',
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       setIsLoading(true)
  //       const param = {
  //         editList: [currReview.id],
  //         editKey: 'review_private',
  //         editValue: true,
  //       }
  //       const res = await inquiryApi.editReview(param, user.id)
  //       if (res.data.code === 200) {
  //         Swal.fire({
  //           title: '정상적으로 수정이 완료 되었습니다.',
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //         await getOneReview(currReview.id, null)
  //         getReadReviews()
  //       } else {
  //         Swal.fire({
  //           title: res?.data.msg,
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //       }
  //     }
  //     setIsLoading(false)
  //   })
  // }

  /**
   * 리뷰 미노출
   * @returns {Promise<void>}
   */
  // const handleReviewNoShow = async () => {
  //   Swal.fire({
  //     title: '미노출 처리하시겠습니까?',
  //     customClass: 'custom-alert',
  //     confirmButtonColor: '#117ffa',
  //     confirmButtonText: '확인',
  //     showCancelButton: true,
  //     cancelButtonText: '취소',
  //   }).then(async (result) => {
  //     if (result.isConfirmed) {
  //       setIsLoading(true)
  //       const param = {
  //         editList: [currReview.id],
  //         editKey: 'review_private',
  //         editValue: false,
  //       }
  //       const res = await inquiryApi.editReview(param, user.id)
  //       if (res.data.code === 200) {
  //         Swal.fire({
  //           title: '정상적으로 수정이 완료 되었습니다.',
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //         await getOneReview(currReview.id, null)
  //         getReadReviews()
  //       } else {
  //         Swal.fire({
  //           title: res?.data.msg,
  //           customClass: 'custom-alert',
  //           confirmButtonColor: '#117ffa',
  //           confirmButtonText: '확인',
  //         })
  //       }
  //     }
  //     setIsLoading(false)
  //   })
  // }

  /**
   * 이전 리뷰 클릭 시 실행
   */
  // const handlePrevReviewClick = async () => {
  //   if (prevReview) {
  //     setIsLoading(true)
  //     await getOneReview(currReview.id, 'prev')
  //   } else {
  //     Swal.fire({
  //       title: '첫번째 리뷰입니다.',
  //       customClass: 'custom-alert',
  //       confirmButtonColor: '#117ffa',
  //       confirmButtonText: '확인',
  //     })
  //   }
  // }

  /**
   * 다음 리뷰 클릭 시 실행
   */
  // const handleNextReviewClick = async () => {
  //   if (nextReview) {
  //     setIsLoading(true)
  //     await getOneReview(currReview.id, 'next')
  //   } else {
  //     Swal.fire({
  //       title: ' 마지막 리뷰입니다.',
  //       customClass: 'custom-alert',
  //       confirmButtonColor: '#117ffa',
  //       confirmButtonText: '확인',
  //     })
  //   }
  // }

  return (
    <Modal
      wrapClassName="review-detail-modal-wrap"
      title="리뷰 사진 상세 보기"
      open={reviewDetailModalShow}
      centered={true}
      onCancel={() => {
        // setCurrReview({})
        setImageList([])
        setReviewDetailModalShow(false)
      }}
      footer={null}
      width="50%"
    >
      <div>
        {imageList && imageList.length > 0 && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              flexWrap: 'wrap',
              marginTop: '10px',
            }}
          >
            {imageList.map((item, idx) => (
              <div key={item.id} style={{ flexShrink: 0 }}>
                <img
                  className="review-main-img"
                  style={{
                    width: '120px',
                    height: '120px',
                    objectFit: 'cover',
                    borderRadius: '8px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                  }}
                  src={`${process.env.REACT_APP_S3_HOST}/${item.imgName}`}
                  alt={`review main img ${idx}`}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      {/* <Spin spinning={isLoading}>
      <Row
          align="middle"
          justify="end"
          style={{ rowGap: '0.5em' }}
          className="review-detail-border-box"
        >
          <Col>
            <Button danger={currReview?.isBest} onClick={handleReviewBest}>
              {currReview.isBest ? '베스트 해제' : '베스트 선정'}
            </Button>
          </Col>
          <Col style={{ marginLeft: '1em' }} onClick={handleReviewShow}>
            <Button disabled={currReview?.reviewPrivate}>노출</Button>
          </Col>
          <Col style={{ marginLeft: '1em' }} onClick={handleReviewNoShow}>
            <Button disabled={!currReview?.reviewPrivate}>미노출</Button>
          </Col>
        </Row>
      <Row align="top" className="review-detail-review-box">
        {isPhotoReview && (
          <Col span={12} className="review-img-box">
            <Row
              justify="center"
              style={{
                marginBottom: '1em',
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
              }}
            >
              {isLoading ? (
                <Skeleton.Image className={`main`} />
              ) : (
                <Image
                className="review-main-img"
                   alt={`review main img`}
                   src={`${process.env.REACT_APP_S3_HOST}/image/review/${
                     currReview?.productId
                   }/${currReview?.createdBy}_${
                     currReview?.id
                   }_${currentPhotoIdx}.${
                     currReview?.reviewTitle.split('-')[1]
                   }`}
                 />
               )}
             </Row>
             <Row
               gutter={8}
               style={{ rowGap: '0.5em' }}
               className={`review-img-list`}
             >
              {renderReviewImageList()?.map((item) => (
                  <Col
                    key={item.idx}
                    onClick={() => handleReviewImageListClick(item.idx)}
                  >
                    <div
                      className={`review-sub-img-box`}
                      style={{
                        border:
                          item.idx === currentPhotoIdx
                            ? '3px solid #117ffa'
                            : '3px solid #868e96',
                      }}
                    >
                      {isLoading ? (
                        <Skeleton.Image className={`sub`} />
                      ) : (
                        <img
                          className="review-sub-img"
                          src={item.source}
                          alt={`review-img-${item.idx}`}
                        />
                      )}
                      <div className={`review-sub-img-hover`}></div>
                    </div>
                  </Col>
                ))}
            </Row>
          </Col>
        )}
        <Col span={isPhotoReview ? 12 : 24} className="review-content-box">
          <Row align="middle">
            {isLoading ? (
              <Skeleton paragraph={{ rows: 1 }} />
            ) : (
              <>
                <Row
                  align="middle"
                  justify="space-between"
                  style={{ width: '100%', paddingBottom: '0.5em' }}
                >
                  <Col style={{ paddingRight: '0.5em' }}>
                    {renderReviewStar(currReview?.reviewScore)}
                  </Col>
                  <Row
                    align="middle"
                    className={`review-create-info`}
                    style={{ color: '#868e96' }}
                  >
                    <Col>{currReview?.createdByName}</Col>
                    <Col>
                      <Divider type="vertical" style={{ margin: '0 0.5em' }} />
                    </Col>
                    <Col>{currReview?.createdAt?.split('T')[0]}</Col>
                  </Row>
                </Row>
                <Row align="middle">{currReview?.productName}</Row>
              </>
            )}
          </Row>
          <Divider style={{ margin: '1em 0' }} />
          <Row align="middle">
            {isLoading ? (
              <Skeleton title={false} paragraph={{ rows: 6 }} />
            ) : (
              <Col
                style={{
                  paddingBottom: '1em',
                  wordBreak: 'break-word',
                }}
              >
                {currReview?.reviewBody}
              </Col>
            )}
          </Row>
        </Col>
      </Row>
      </Spin> */}
    </Modal>
  )
}

export default ReviewDetailComponent
